export const UPDATE_CART = 'UPDATE_CART'
export const UPDATE_COUPON = 'UPDATE_COUPON'
export const UPDATE_NEW_PET = 'UPDATE_NEW_PET'
export const UPDATE_TREATS = 'UPDATE_TREATS'
export const UPDATE_ALL = 'UPDATE_ALL'
export const UPDATE_HIDE_CART = 'UPDATE_HIDE_CART'

